import React from 'react'
import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogSavePostSendConfirmationProps
  extends Omit<DialogProps, 'children'> {
  isLoading?: boolean
  onConfirm?: () => void
}

const DialogSavePostSendConfirmation = ({
  isLoading = false,
  onConfirm = () => {},
  ...props
}: DialogSavePostSendConfirmationProps) => {
  const handleCheckAgain = () => {
    props.onClose?.()
  }

  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent
        className="!rounded-lg"
        aria-labelledby="save-kinerja-harian-dialog-title"
        aria-describedby="save-kinerja-harian-dialog-description"
      >
        <div className="p-6">
          <Image
            alt=""
            src="/illustrations/img-notification-document.png"
            width={84}
            height={84}
          />
          <Text
            variant="display-sm"
            className="mt-4"
            id="save-kinerja-harian-dialog-title"
            as="h2"
          >
            Catatan hanya dapat diubah satu kali saja
          </Text>

          <Text
            variant="body-lg"
            color="subdued"
            className="mt-2"
            id="save-kinerja-harian-dialog-description"
          >
            Setelah dikirim ke E-Kinerja, catatan Kinerja Harian Anda hanya
            dapat diubah satu kali saja. Pastikan sudah sesuai.
          </Text>

          <div className="flex gap-5 mt-6">
            <Button
              size="lg"
              color="white"
              disabled={isLoading}
              onClick={handleCheckAgain}
              data-testid="btn-check-again"
            >
              Cek ulang
            </Button>
            <Button
              size="lg"
              className="w-[190px]"
              color="black"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={onConfirm}
              data-testid="btn-confirm"
            >
              Simpan Perubahan
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogSavePostSendConfirmation
